var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { observable, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
var SendMessage = (function (_super) {
    __extends(SendMessage, _super);
    function SendMessage(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        makeObservable(_this);
        _this.onTypeMessage = _this.onTypeMessage.bind(_this);
        _this.onFileSelected = _this.onFileSelected.bind(_this);
        _this.sendMessage = _this.sendMessage.bind(_this);
        _this.setMessage = _this.setMessage.bind(_this);
        return _this;
    }
    Object.defineProperty(SendMessage.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (React.createElement("div", { className: "action" },
                this.renderSelectedFile(),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "action-element col-xs-8 col-md-10" },
                        React.createElement("textarea", { className: "pxl-form-control pxl-form-textarea", rows: 1, value: this.message, onChange: this.setMessage, onKeyDown: this.onTypeMessage, placeholder: "Type a message..." })),
                    React.createElement("div", { className: "action-element col-xs-4 col-md-2" },
                        React.createElement("div", { className: "file-upload pxl-btn" },
                            React.createElement("span", null,
                                React.createElement("i", { className: "icon-attach" })),
                            React.createElement("input", { type: "file", className: "upload", onChange: this.onFileSelected }))))));
        }
    });
    Object.defineProperty(SendMessage.prototype, "onTypeMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (keyboardEvent) {
            var enterCode = 13;
            if (keyboardEvent.keyCode === enterCode && keyboardEvent.shiftKey === false) {
                keyboardEvent.preventDefault();
                this.sendMessage();
            }
        }
    });
    Object.defineProperty(SendMessage.prototype, "onFileSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (changeEvent) {
            var messageStore = this.props.store.messageStore;
            if (changeEvent.target.files) {
                messageStore.selectFile(changeEvent.target.files[0]);
            }
            changeEvent.target.value = '';
        }
    });
    Object.defineProperty(SendMessage.prototype, "setMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var message = e.target.value;
            this.message = message;
        }
    });
    Object.defineProperty(SendMessage.prototype, "renderSelectedFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var messageStore = this.props.store.messageStore;
            if (messageStore.file) {
                return (React.createElement("span", { className: "upload pxl-c11-1" },
                    React.createElement("span", { className: "icon-doc pxl-text-cerulean" }),
                    messageStore.file.name,
                    React.createElement("span", { className: "icon-cancel pxl-text-skyblue-dark", onClick: messageStore.deleteFile })));
            }
            return null;
        }
    });
    Object.defineProperty(SendMessage.prototype, "validToSendMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var messageStore = this.props.store.messageStore;
            return this.isMessageEmpty() === false || messageStore.hasAttachment;
        }
    });
    Object.defineProperty(SendMessage.prototype, "sendMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var messageStore, _a, masterAccountId, userId, entityType, entityId, message, messageId;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            messageStore = this.props.store.messageStore;
                            if (messageStore.hasAttachment && messageStore.validateFile() === false) {
                                return [2, Promise.resolve()];
                            }
                            if (this.validToSendMessage() === false) {
                                return [2, Promise.resolve()];
                            }
                            _a = this.props, masterAccountId = _a.masterAccountId, userId = _a.userId, entityType = _a.entityType, entityId = _a.entityId;
                            if (messageStore.isSending) {
                                return [2, Promise.resolve()];
                            }
                            message = this.message;
                            this.message = '';
                            return [4, messageStore.sendMessage(masterAccountId, userId, entityType, entityId, message)];
                        case 1:
                            messageId = _b.sent();
                            return [4, messageStore.setLastReadMessage(masterAccountId, entityType, entityId, messageId)];
                        case 2:
                            _b.sent();
                            this.props.onMessageSent();
                            messageStore.getMessages(masterAccountId, userId, entityType, entityId);
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(SendMessage.prototype, "isMessageEmpty", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.message || this.message.trim().length === 0) {
                return true;
            }
            return false;
        }
    });
    __decorate([
        observable
    ], SendMessage.prototype, "message", void 0);
    return SendMessage;
}(React.Component));
export { SendMessage };
export default inject('store')(observer(SendMessage));
